if (document.querySelector('.template-product') && window.innerWidth < 750) {
  const observer = new MutationObserver(() => {
    const yotpoLayout = document.querySelector('.yotpo-main-layout');
    const reviewBtnWrapper = document.querySelector('.yotpo-new-review-btn-wrapper');
    if (yotpoLayout && reviewBtnWrapper) {
      yotpoLayout.appendChild(reviewBtnWrapper);
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}